// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2kXpL","addWidgetButton":"Header_addWidgetButton__37Czt","dashboardTabs":"Header_dashboardTabs__286gw","active":"Header_active__1xW_G"};